<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="entities">
        <dx-data-grid #dataGrid
                      [dataSource]="entities"
                      [columnAutoWidth]="false"
                      (onToolbarPreparing)="onToolbarPreparing($event)"
                      (onExporting)="onExporting($event)"
                      >
            <dxi-column dataField="entityTypeName" caption="Entity Type" width="100" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="userName" caption="Username" width="100"></dxi-column>
            <dxi-column dataField="action" caption="Action" width="100"></dxi-column>
            <dxi-column dataField="when" caption="When" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="primaryKey" caption="Id" width="100"></dxi-column>
            <dxi-column dataField="data" caption="Changes" cellTemplate="changesTemplate"></dxi-column>

            <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let cell of 'linkTemplate'">
                <a [routerLink]="[]" (click)="open(cell.data)">{{ cell.value || '(blank)' }}</a>
            </div>

            <div *dxTemplate="let cell of 'changesTemplate'">
                <i class="fa fa-plus" (click)="showChanges(cell.data)" *ngIf="!cell.data.showChanges && cell.data.action !== 'Insert'"> Show Changes</i>
                <i class="fa fa-minus" (click)="hideChanges(cell.data)" *ngIf="cell.data.showChanges"> Hide Changes</i>
                <table class="table m-t-sm" *ngIf="cell.data.showChanges">
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th>Old Value</th>
                            <th>New Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let change of cell.data.changes">
                            <td>{{change.ColumnName}}</td>
                            <td>{{change.OriginalValue}}</td>
                            <td>{{change.NewValue}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'"></div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="entities" class="me-3"><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span>
            </div>
        </dx-data-grid>
    </div>
</div>
